import { render, staticRenderFns } from "./Grupos_investigacion.vue?vue&type=template&id=32a7525a&"
import script from "./Grupos_investigacion.vue?vue&type=script&lang=js&"
export * from "./Grupos_investigacion.vue?vue&type=script&lang=js&"
import style0 from "./Grupos_investigacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports